export enum SupplierMappingTypeEnum {
    PackingSupplier='Packing Supplier',
    HR_Agent='HR Agent',
    EndCustomer='EndCustomer',
}